import { render } from "./LayoutMain.vue?vue&type=template&id=38eb5080&scoped=true&ts=true"
import script from "./LayoutMain.vue?vue&type=script&lang=ts"
export * from "./LayoutMain.vue?vue&type=script&lang=ts"

import "./LayoutMain.vue?vue&type=style&index=0&id=38eb5080&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38eb5080"]])

export default __exports__